var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 5 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.715,
    height: 22.715
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.398 1.288a1.682 1.682 0 0 0-2.343-.232A1.682 1.682 0 0 0 1.287 3.4l18.031 18.032a1.682 1.682 0 0 0 2.344.232 1.682 1.682 0 0 0-.232-2.344Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "np_menu_1591047_000000",
    d: "M19.316 1.287a1.682 1.682 0 0 1 2.343-.232 1.682 1.682 0 0 1-.232 2.344l-18.03 18.03a1.682 1.682 0 0 1-2.344.233 1.682 1.682 0 0 1 .232-2.344Z"
  })));
};
export default SvgClose;